<template>
  <div
    class="select-with-icon"
    :class="[`select-with-icon_${value.color}`]"
  >
    <i
      v-if="value.icon"
      :class="['icon-' + value.icon]"
    />
    <div
      v-else
      class="select-with-icon__svg"
      v-html="value.svgIcon"
    />
    <div>
      {{ value.name }}
    </div>
      <BBSelectImage
        :label="column.label"
        :textTransformNone="column.textTransformNone"
        :placeholder="column.placeholder"
        :searchable="column.searchable"
        :isHideSearch="column.isHideSearch"
        :hideImage="column.hideImage"
        :options="column.options"
        :clearable="column.clearable"
        :item="{row, column}"
        @change="setSelect"
      />
  </div>
</template>

<script>

import BBSelectImage from '@/components/Main/Inputs/BBSelectImage'
import {get} from 'lodash'

export default {
  name: 'SelectWithIcon',
  components: {
    BBSelectImage
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    value () {
      const { prop, options = [] } = this.column
      const value = get(this.row, prop, '')
      return options.find((el) => el.id === value)
    }
  },
  methods: {
    setSelect ({ id }) {
      this.$set(this.row, 'status', id)
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('edit', currentElem)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

  .select-with-icon {
    display: flex;
    align-items: center;
    grid-gap: 0 6px;
    cursor: pointer;

    &_yellow {
      color: $color-la-rioja;
    }

    &_blue {
      color: $color-denim;
    }

    &_green {
      color: $color-japanese-laurel;
    }

    &_red {
      color: $color-pomegranate;
    }

    &__svg {
      display: flex;
    }
  }
</style>

<style lang="scss">

  .select-with-icon {

    .bb-loader-select {
      position: absolute;
      top: -10px;
    }

    .bb-loader-select-header {
      width: 100%;
      height: 40px !important;
    }

    .bb-loader-select-dropdown-menu {
      min-width: 160px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/SelectWithIcon/SelectWithIcon.vue